import styled from 'styled-components';
import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';


function Contato({item,DadosAPI }) {

    var texto = item.texto;
  

    //Navegacao lista de pordutos

    const navigate = useNavigate();

     


    return (
         <>
            <div style={{margin:'auto', padding: '0 5%', marginTop:30}}>
                <div dangerouslySetInnerHTML={{ __html: texto }} />
            </div>
         </>
    );
}

export default Contato;
